import { Component, Input } from '@angular/core';
import { TenantService } from '../../../core/services/tenant.service';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  @Input() logoUrl: string = ''
  @Input() logoWidth: string = '169px'
  @Input() logoHeight: string = '36px'
  @Input() nameBranch: string = ''
  @Input() headerLogoUrl: string = ''
  @Input() headerLogoWidth: string = '131px'
  @Input() headerLogoHeight: string = '28px'
  @Input() isAdmin: boolean = false;
  constructor(private tenantService: TenantService, private authService: AuthService) {}

  get tenant() {
    return this.tenantService.current;
  }

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  get displayName(): string {
    return this.authService.getDisplayName() ?? 'User';
  }

  logout(): void {
    this.authService.logout().subscribe();
  }

  get headerLogoStyle(): Record<string, string> {
    return {
      'background-image': `url('${this.headerLogoUrl}')`,
      width: this.headerLogoWidth,
      height: this.headerLogoHeight,
    };
  }
}
